<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 15 16">
    <path
      d="M0.509033 1.67575C0.509033 1.18901 0.903613 0.794434 1.39035 0.794434H13.7288C14.2156 0.794434 14.6101 1.18901 14.6101 1.67575V1.67575C14.6101 2.16249 14.2156 2.55707 13.7288 2.55707H1.39035C0.903614 2.55707 0.509033 2.16249 0.509033 1.67575V1.67575ZM3.15299 14.8955C3.15299 14.4088 3.54757 14.0142 4.03431 14.0142H11.0849C11.5716 14.0142 11.9662 14.4088 11.9662 14.8955V14.8955C11.9662 15.3823 11.5716 15.7769 11.0849 15.7769H4.03431C3.54757 15.7769 3.15299 15.3823 3.15299 14.8955V14.8955ZM3.15299 6.08235C3.15299 5.59561 3.54757 5.20103 4.03431 5.20103H11.0849C11.5716 5.20103 11.9662 5.59561 11.9662 6.08235V6.08235C11.9662 6.56909 11.5716 6.96367 11.0849 6.96367H4.03431C3.54757 6.96367 3.15299 6.56909 3.15299 6.08235V6.08235ZM0.509033 10.4889C0.509033 10.0022 0.903613 9.60763 1.39035 9.60763H13.7288C14.2156 9.60763 14.6101 10.0022 14.6101 10.4889V10.4889C14.6101 10.9757 14.2156 11.3703 13.7288 11.3703H1.39035C0.903614 11.3703 0.509033 10.9757 0.509033 10.4889V10.4889Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
